import React, {Fragment, Component} from 'react';
import Grid from 'styled-components-grid';
import Tab from '../common/tabs/Tab';
import TabBar from '../common/tabs/TabBar';
import {matchPath} from 'react-router-dom';
import DefaultNavigation, {getPages} from '../common/DefaultNavigation';
import ReportsResultPage from './ReportsResultPage';
import SettingsTabBar from '../settings/SettingsTabBar';
import queryString from 'query-string';
import Settings from '../settings/Settings';
import {QUERY_KEY_SETTINGS} from '../settings/types';
import gql from 'graphql-tag';
import {Query} from 'react-apollo';
import Loading from '../settings/Loading';
import Error from '../settings/Error';

const pageInfos = [
  {label: 'Störungen', slug: 'disfunctions', component: ReportsResultPage},
  {label: 'Produktivität', slug: 'productivity', component: ReportsResultPage},
  {label: 'OEE', slug: 'oee', component: ReportsResultPage},
  {label: 'Weiteres', slug: 'others', component: ReportsResultPage},
];

const GET_SETTINGS = gql`
  {
    settings(input: {}) {
      id
      period {
        type
        range {
          start
          end
        }
      }
      workplaces {
        type
        ids
      }
      interruptingDisfunctions {
        type
        ids
      }
      notInterruptingDisfunctions {
        type
        ids
      }
      products {
        type
        ids
      }
      productStates {
        type
        ids
      }
      shifts {
        type
        ids
      }
    }
  }
`;

class ReportsPageContainer extends Component {
  render() {
    const pages = getPages(this.props.match, pageInfos);
    const {
      location: {search, pathname},
    } = this.props;
    const query = queryString.parse(search);
    const settingsType = query[QUERY_KEY_SETTINGS];
    return (
      <Fragment>
        <TabBar>
          {pages.map(({label, path, url, slug}) => (
            <Grid.Unit key={slug} size={1 / 4}>
              <Tab
                selected={matchPath(pathname, {path})}
                onClick={() => {
                  this.props.history.push(`${url}${search}`);
                }}>
                {label}
              </Tab>
            </Grid.Unit>
          ))}
        </TabBar>
        <SettingsTabBar
          type={settingsType}
          settings={this.props.settings}
          toggleSettings={(type) => {
            const newSettingsType = type === settingsType ? undefined : type;
            const newQuery = {...query, [QUERY_KEY_SETTINGS]: newSettingsType};
            this.props.history.push({
              pathname,
              search: queryString.stringify(newQuery),
            });
          }}
        />
        {settingsType ? (
          <Settings {...this.props} type={settingsType} />
        ) : (
          <DefaultNavigation {...this.props} pages={pages} />
        )}
      </Fragment>
    );
  }
}

const ReportsPage = (props) => (
  <Query query={GET_SETTINGS}>
    {({loading, error, data}) => {
      if (loading) return <Loading />;
      if (error) return <Error>{error.message}</Error>;
      return <ReportsPageContainer settings={data.settings} {...props} />;
    }}
  </Query>
);

export default ReportsPage;
